const RulesJs = {
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '事件名称为必填项'
        }
    ],
    code: [
        {
            required: true,
            message: '事件编码为必填项',
            trigger: 'blur'
        }
    ],
    level: [
        {
            required: true,
            trigger: 'blur',
            message: '事件等级为必填'
        }
    ],
    module: [
        {
            required: true,
            trigger: 'change',
            message: '请选择所属子系统'
        }
    ],
    'threshold_setting.data_type': [
        {
            trigger: 'change',
            required: true,
            validator: (rule, value, callback) => {
                if (value) {
                    callback()
                } else {
                    callback(new Error('请选择数据类型'))
                }
            }
        }
    ],
    'threshold_setting.input_type': [
        {
            trigger: 'change',
            required: true,
            validator: (rule, value, callback) => {
                if (value) {
                    callback()
                } else {
                    callback(new Error('请选择数据项类型'))
                }
            }
        }
    ],
    // 'threshold_setting.rules': [
    //     {
    //         trigger: 'change',
    //         required: true,
    //         validator: (rule, value, callback) => {
    //             if (value?.length) {
    //                 callback()
    //             } else {
    //                 callback(new Error('请选择验证规则'))
    //             }
    //         }
    //     }
    // ],
    limit_settingItem: [
        {
            required: true,
            trigger: 'change',
            validator: (rule, value, callback) => {
                if (!value.type) {
                    callback(new Error('请选择值类型'))
                } else if (!value.title) {
                    callback(new Error('请输入标题'))
                } else if (!value.value && (value.value !== '0' || value.value !== '0')) {
                    callback(new Error('请输入限值'))
                } else {
                    callback()
                }
            }
        }
    ]
}

const FormJsData = {
    id: '',
    name: '',
    code: '',
    level: '',
    is_set: 0,
    module: '',
    list_order: 0,
    is_threshold: 0,
    threshold_setting: {
        data_type: '',
        input_type: '',
        rules: [],
        unit: '',
        options: ''
    },
    limit_setting: [
        {
            title: '',
            placeholder: '',
            value: '',
            required: 1,
            type: ''
        }
    ],
    in_range: 0,
    status: 1,
    visible: 1
}
export { RulesJs, FormJsData }
